import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppState } from 'src/app/app.reducer';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetDocActivityLog } from '../_store/resources.actions';
import { Location } from '@angular/common';

@Component({
  selector: 'app-doc-activity-log',
  templateUrl: './doc-activity-log.component.html',
  styleUrls: ['./doc-activity-log.component.scss']
})
export class DocActivityLogComponent implements OnInit {
  folderId: any;
  activityLog: any;

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    public location: Location,

) {
    this.activatedRoute.params.subscribe(params => {
        this.folderId = (params || {}).folderId;
        this.store.dispatch(new GetDocActivityLog(this.folderId));
    });
}

ngOnInit() {
    this.store.select(state => state.resources.docActivityLog).subscribe(activityLog => {
        if (Object.keys(activityLog).length) {
            console.log('ActivityLog', activityLog);
            this.activityLog = activityLog.map(log => {
                if (log) {
                    const message = this.buildLogMessage(log);
                    return {
                        ...log,
                        logMsg: message,
                        displayPic: `${environment.host}/user/getImage/${log.activityBy}`
                    };
                }
            });
        }
    });
}

    buildLogMessage(log) {
    function getNamesFromIds(userIdsArr) {
        let namesArr: Array<any> = [];
        let namesStr: string;
        userIdsArr.map(item => {
            namesArr.push(`${item.firstName} ${item.middleName} ${item.lastName} `);
        });
        namesStr = namesArr.join();

        return namesStr ? namesStr : "none";
    }

    const userName = (log.activityBy.firstName || '') + ' ' + (log.activityBy.middleName || '') + ' ' + (log.activityBy.lastName || '');
    switch (log.activityType) {
        case 'PROJECT_CREATED':
            return `${userName} created this Project`;
        case 'TASK_DATES_UPDATED':
            return `${userName} updated the task start date`;
        case 'CREATE_TASK_FROM_PROJECT':
            return `${userName} created task ${log.taskId ? log.taskId.name : ""}`;
        case 'PROJECT_MEMBERS_UPDATED':
            return `${userName} added ${getNamesFromIds(log.addedUserIds)} as a core team member`;
        case 'ADDED_FUND_RELEASE':
            return `${userName} added ${log.updatedCost} INR to fund released.`;
        case 'ADDED_FUND_UTILIZATION':
            return `${userName} added ${log.updatedCost} INR to fund utilised.`
        case 'UPDATED_FUND_RELEASE':
            return `${userName} updated fund release to ${log.updatedCost} INR`;
        case 'UPDATED_FUND_UTILIZATION':
            return `${userName} updated fund utilization to ${log.updatedCost} INR`;
        case 'UPDATED_CITIIS_GRANTS':
            return `${userName} updated citiis grants to ${log.updatedCost} INR`;
        case 'UPDATED_PROJECT_COST':
            return `${userName} updated project cost to ${log.updatedCost} INR`;
        case 'REPLACE_USER':
            return;
        default: return log.message;

    }
}

setDefaultPic(item) {
    item.displayPic = "assets/images/user_profile.svg"
}

}
